const LEGACY_COUNTRY_CODE = "+92";
const LEGACY_PHONE_NUMBER = "333663322";

export function requiresPhoneUpdate(user = {}) {
  if (Number(user.PortalID) !== 1) return false;
  if (user.PhoneRequired === true) return true;
  if (user.PhoneRequired === false) return false;

  const countryCode = String(user.CountryCode || "").replace(/\D/g, "");
  const phoneNumber = String(user.PhoneNumber || "").replace(/\D/g, "");

  return (
    !countryCode ||
    !phoneNumber ||
    (countryCode === LEGACY_COUNTRY_CODE.replace(/\D/g, "") &&
      phoneNumber === LEGACY_PHONE_NUMBER)
  );
}
